const tokens = require('../../design-token.json');

/**
 * Utilities for accessing design tokens
 */
module.exports = {
    space: (name) => {
        return parseInt(tokens.space[name], 10);
    },
    token: () => { return tokens; }
};